import React, { useState } from 'react';
import { ButtonBase } from '@material-ui/core';

export default function ShowMultiValues({ values = [], itemRender }) {
  const [showAll, setShowAll] = useState(false);

  const visibleValues = showAll ? values : values?.slice(0, 3);
  const shouldShowToggle = values?.length > 3 && !showAll;
  const extraCount = values?.length - 3;

  return (
    <div className='extraCount-wrapper'>
      {visibleValues?.map((value, index) => (
        <div
          key={index}
          className='mb-1'
        >
          {itemRender ? itemRender(value) : value}
        </div>
      ))}
      {shouldShowToggle && (
        <ButtonBase
          className='extraCount-badge-wrapper'
          onClick={() => setShowAll(true)}
        >
          <span className='extraCount-badge'>+{extraCount}</span>
        </ButtonBase>
      )}
    </div>
  );
}
